import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { colorsButton } from '../../../app/colors';
import { fontSizes, fontWeights, truncateCss } from '../../../app/typography';
import { gray, red } from '@kizen/kds/Colors';

const ButtonGroupButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  height: 36px;
  border: 1px solid ${gray['gray-500']};
  border-radius: 2px;
  color: ${gray['gray-600']};
  & > span {
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.small};
    ${truncateCss};
  }
  background-color: ${gray['gray-50']};
  &:disabled {
    background-color: ${gray['gray-300']};
  }
  &:not(:disabled):hover {
    border-color: ${colorsButton.blue.hover};
  }
  &:focus {
    outline: none;
    border-color: ${colorsButton.blue.hover};
  }
  ${({ selected }) =>
    selected &&
    css`
      color: ${colorsButton.blue.hover};
      border-color: ${colorsButton.blue.hover};
      &:disabled {
        color: ${gray['gray-800']};
        border-color: ${gray['gray-800']};
      }
    `}
  ${({ error }) =>
    error &&
    css`
      border-color: ${red['red-500']};
    `}
`;

export default function ButtonGroupButton({ option, ...props }) {
  return (
    <ButtonGroupButtonBase {...props}>
      <span>{option?.label || '—'}</span>
    </ButtonGroupButtonBase>
  );
}
